<div class="flex flex-col gap-4">
  @for (formGroup of periodForms().controls; track $index) {
    <div class="flex justify-between items-center gap-6 p-4 rounded-xl border-1 border-primary-50">
      <div class="flex-1">
        <elcia-date-picker [control]="formGroup.controls.startDate" [label]="'accounting-period.start-date' | translate"/>
      </div>
      <div class="flex-1">
        <elcia-date-picker [control]="formGroup.controls.endDate" [label]="'accounting-period.end-date' | translate"/>
      </div>
      <elcia-check-box [control]="formGroup.controls.isClosed" [label]="'accounting-period.is-closed' | translate"/>
      <elcia-button
        [icon]="formGroup.enabled ? 'save' : 'edit'"
        [severity]="formGroup.enabled ? 'primary' : 'secondary'"
        (click)="toggleFormGroup(formGroup.value.id)"/>
    </div>
  }

  <div class="flex justify-between items-center gap-6 p-4 rounded-xl border-1 border-dashed border-primary-100">
    <div class="flex-1">
      <elcia-date-picker [control]="createForm.controls.startDate" [label]="'accounting-period.start-date' | translate"/>
    </div>
    <div class="flex-1">
      <elcia-date-picker [control]="createForm.controls.endDate" [label]="'accounting-period.end-date' | translate"/>
    </div>
    <elcia-check-box [control]="createForm.controls.isClosed" [label]="'accounting-period.is-closed' | translate"/>
    <elcia-button
      icon="plus"
      severity="primary"
      [disabled]="createForm.invalid"
      (click)="submitCreate()"/>
  </div>
</div>
